// extracted by mini-css-extract-plugin
module.exports = {"timer":"_9137","item":"_4732","divider":"_19213"};